module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Property Value":"Attributwert","Only prices can be edited for existing values":"Für bestehende Werte sind nur Preise pflegbar","Value":"Wert","Prices":"Preise"}}')
  delete Component.options._Ctor
}
